import React, {useState} from 'react';
import colours from 'styles/colours';

const dropdownStyles = {
    position: 'absolute',
    right: 0,
    top: 'calc(100% + 6px)',
    minWidth: 180,
    background: colours.background.main,
    border: `1px solid ${colours.border.dropdown}`,
    borderRadius: 8,
    boxShadow: colours.shadow.dropdown,
    zIndex: 300,
    overflow: 'hidden',
};

const headerStyles = {
    padding: '10px 16px',
    borderBottom: `1px solid ${colours.border.dropdownDivider}`,
    fontSize: 12,
    color: colours.font.disabled,
    userSelect: 'none',
    wordBreak: 'break-all',
};

const menuItemStyles = ({active, focused}) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    width: '100%',
    padding: '10px 16px',
    background: active ? colours.background.listRow.hover : 'transparent',
    border: 'none',
    borderLeft: active ? `3px solid ${colours.border.primary.highlight}` : '3px solid transparent',
    textAlign: 'left',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: '0.04em',
    color: active ? colours.border.primary.shadow : colours.font.emphasis,
    fontFamily: 'inherit',
    transition: 'background 0.15s ease, border-color 0.15s ease, color 0.15s ease',
    boxSizing: 'border-box',
    outline: focused ? `2px solid ${colours.border.primary.highlight}` : 'none',
    outlineOffset: focused ? '-2px' : '0',
});

const signOutIconStyles = (active) => ({
    fontFamily: '"Material Symbols Outlined Uniportal"',
    fontSize: 18,
    lineHeight: 1,
    color: 'inherit',
    fontVariationSettings: `"FILL" ${active ? 1 : 0}`,
    transition: 'font-variation-settings 0.2s',
    userSelect: 'none',
});

const SignedInAs = ({username}) => (
    <div style={headerStyles}>
        Signed in as<br/>
        <strong style={{color: colours.font.emphasis}}>{username}</strong>
    </div>
);

const MenuItem = ({icon, label, onClick}) => {
    const [hovered, setHovered] = useState(false);
    const [focused, setFocused] = useState(false);
    const active = hovered || focused;

    return (
        <button
            style={menuItemStyles({active, focused})}
            onClick={onClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
        >
            <span className="material-symbols-outlined" aria-hidden="true" style={signOutIconStyles(active)}>
                {icon}
            </span>
            {label}
        </button>
    );
};

export default function Dropdown({username, onSignOut}) {
    return (
        <div style={dropdownStyles}>
            {username && <SignedInAs username={username}/>}
            <MenuItem icon="logout" label="Sign out" onClick={onSignOut}/>
        </div>
    );
}
